import MemberlinkWrapper from "../../../shared/MemberlinkWrapper.tsx";
import StaticTimeAgo from "../../../shared/StaticTimeAgo.tsx";
import UpdatedIndicator from "../../../shared/UpdatedIndicator.tsx";
import ReplyContextMenu from "./ReplyContextMenu.tsx";
import { ActivityReply } from "../../../../@types/activities.ts";
import TranslationControls from "../../../shared/TranslationControls.tsx";

type ReplyHeaderArgs = {
  replyId: string;
  activityId: string;
  can: ActivityReply["can"];
  author: ActivityReply["author"];
  published: string;
  contentUpdatedAt?: string | null;
  contentUpdatedByName?: string | null;
  quoteReply: () => void;
  setShowComposer: (show: boolean) => void;
  translatedContent: {
    language?: string;
    content?: string;
  };
  setTranslatedContent: (props: {
    language?: string;
    content?: string;
    quoted_content?: string;
  }) => void;
  type: "replies" | "answers";
};

export default function ReplyHeader({
  replyId,
  activityId,
  can,
  author,
  published,
  contentUpdatedAt,
  contentUpdatedByName,
  quoteReply,
  setShowComposer,
  translatedContent,
  setTranslatedContent,
  type = "replies",
}: ReplyHeaderArgs) {
  return (
    <div className="flex justify-between items-start">
      <div>
        <MemberlinkWrapper url={author.url} className="font-bold text-sm pt-1">
          {author.displayName}
          {author.detection_profile_field &&
            ` (${author.detection_profile_field})`}
          {author.is_external && ` (${I18n.t("js.external_member.badge")})`}
        </MemberlinkWrapper>
        <div className="reply-meta flex gap-1 text-xs text-muted items-center">
          <a
            href={`/activities/${activityId}/replies/${replyId}`}
            className="text-muted"
          >
            <StaticTimeAgo date={published} />
          </a>
          {contentUpdatedAt && (
            <UpdatedIndicator
              updatedAt={contentUpdatedAt}
              updatedByName={contentUpdatedByName || ""}
              size="xs"
              separatorBefore
            />
          )}
        </div>
      </div>
      {!window.isApp && (
        <div className="flex items-center print:hidden">
          {Preload.current_network.config?.translations?.deep_l?.enabled && (
            <TranslationControls
              object_language={translatedContent.language || "ORIGINAL"}
              types={[
                type === "replies" ? "activity_comment" : "activity_answer",
              ]}
              target_id={`${activityId}:${replyId}`}
              resetTranslation={() =>
                setTranslatedContent({ language: undefined })
              }
              translateObject={(data, language) =>
                setTranslatedContent({
                  language,
                  content: data.text,
                  quoted_content: data.quoted_message_text,
                })
              }
            />
          )}
          <ReplyContextMenu
            can={can}
            replyId={replyId}
            activityId={activityId}
            setShowComposer={setShowComposer}
            quoteReply={quoteReply}
            type={type}
          />
        </div>
      )}
    </div>
  );
}
